import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBag: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bag, luggage, buggage "><path d="M2.75 20.25H21.25V7.75H2.75V20.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M21 12.75H3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 12.75L12.0022 15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.00391 7.75V3.75H16.0039V7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBag;
